import type { Member } from '@assembly-web/services';

export function isAdminMember(member: Member) {
  return member.role.includes('Admin') || member.role.includes('Owner');
}
